module.exports = __webpack_public_path__ + "static/media/walkthrough_women.fadb263e.svg";